import { Formik, Form, Field } from "formik";
import { TextField, Button, MenuItem } from "@mui/material";
import * as yup from "yup";
import React, { Fragment, useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import sphereimg from "../../../images/ball.png";
import coneimg from "../../../images/cone.png";
import cube from "../../../images/cube.png";
import cylinderimg from "../../../images/cylinder.png";
import rectangularimg from "../../../images/prism.png";
import capsuleimg from "../../../images/capsule.png";
import conicalimg from "../../../images/conical-frustum.png";
import ellipsoidimg from "../../../images/ellipsoid.png";
import pyramidimg from "../../../images/square-pyramid.png";
import tubeimg from "../../../images/tube.png";
const TITLE = "حساب حجم الأشكال الهندسية - حاسبة الحجم";
const DESCRIPTION =
  "هذه الحاسبة المجانية تقوم ب حساب حجم الأشكال الشائعة بما في ذلك الكرة، المخروط، المكعب، الأسطوانة، الكبسولة، الغطاء، الجذع المخروطي، الشكل البيضوي، الهرم، الانبوب والمزيد.";
const KEYWORDS =
  "حاسبة حجم, الكرة, المخروط, المكعب, الأسطوانة, الكبسولة, الغطاء, الجذع المخروطي, الشكل البيضوي, الهرم, الانبوب, حساب الأشكال, حساب الحجم, آلة حاسبة مجانية, حساب حجم الأشكال الهندسية, الأشكال الهندسية, حساب  حجم الكرة, حساب حجم المخروط, حساب حجم المكعب, حساب حجم الأسطوانة";
const OG_URL = "https://do-calculate.com/calculator/ar/volumes/";
const conversionMap = {
  سنتيمتر: 0.01,
  بوصة: 0.0254,
  متر: 1,
  كيلومتر: 1000,
  قدم: 0.3048,
  ميل: 1609.34,
};
const sphereSchema = yup.object().shape({
  radius: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
});
const initialSphereValues = {
  radius: "",
  unit: "متر",
};
const sharedSmStyle =
{
  width: "160px",
  ml: "10px",
  bgcolor: "#f9f9f9",
  "&  .MuiFormHelperText-root.Mui-error": {
    backgroundColor: "rgb(229, 230, 227) !important",
    margin: 0,
    padding: "8px 0 0 41px",
  },
}
const sharedSxClear =
{
  backgroundColor: "rgb(108,117,125)",
  fontSize: "15px",
  marginRight: "25px",
  padding: "5px 25px",
  color: "white",
}
const coneSchema = yup.object().shape({
  baseRadius: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  height: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
});
const initialConeValues = {
  baseRadius: "",
  height: "",
  baseRadiusUnit: "متر",
  heightUnit: "متر",
};
const cubeSchema = yup.object().shape({
  edge: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
});
const initialCubeValues = {
  edge: "",
  unit: "متر",
};
const cylinderSchema = yup.object().shape({
  baseRadius: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  height: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
});
const initialCylinderValues = {
  baseRadius: "",
  height: "",
  baseRadiusUnit: "متر",
  heightUnit: "متر",
};
const rectangularSchema = yup.object().shape({
  length: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  width: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  height: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
});
const initialRectangularValues = {
  length: "",
  width: "",
  height: "",
  lengthUnit: "متر",
  widthUnit: "متر",
  heightUnit: "متر",
};
const capsuleSchema = yup.object().shape({
  baseRadius: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  height: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
});
const initialCapsuleValues = {
  baseRadius: "",
  height: "",
  baseRadiusUnit: "متر",
  heightUnit: "متر",
};
const conicalSchema = yup.object().shape({
  topRadius: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  bottomRadius: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  height: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
});
const initialConicalValues = {
  topRadius: "",
  bottomRadius: "",
  height: "",
  topRadiusUnit: "متر",
  bottomRadiusUnit: "متر",
  heightUnit: "متر",
};
const ellipsoidSchema = yup.object().shape({
  axis1: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  axis2: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  axis3: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
});
const initialEllipsoidValues = {
  axis1: "",
  axis2: "",
  axis3: "",
  axis1Unit: "متر",
  axis2Unit: "متر",
  axis3Unit: "متر",
};
const pyramidSchema = yup.object().shape({
  baseEdge: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  height: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
});
const initialPyramidValues = {
  baseEdge: "",
  height: "",
  baseEdgeUnit: "متر",
  heightUnit: "متر",
};
const tubeSchema = yup.object().shape({
  outerDiameter: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
  innerDiameter: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة")
    .when("outerDiameter", (outerDiameter, schema) => {
      return schema.test(
        "is-greater",
        "القطر الداخلي يجب ان يكون اصغر من القطر الخارجي",
        (innerDiameter) => outerDiameter > innerDiameter
      );
    }),
  length: yup
    .number()
    .typeError("تأكد من القيمة بأن تكون عدد")
    .required("تأكد من ادخال قيمة")
    .max(1000000000, "الرقم كبير جدا")
    .min(0, "تأكد من عدم ادخال قيم سالبة"),
});
const initialTubeValues = {
  outerDiameter: "",
  innerDiameter: "",
  length: "",
  outerDiameterUnit: "متر",
  innerDiameterUnit: "متر",
  lengthUnit: "متر",
};
const VolumesCalculator = () => {
  const [sphereVolume, setSphereVolume] = useState("");
  const [convertedSphereUnit, setConvertedSphereUnit] = useState("متر");
  const onSubmitSphere = (values) => {
    const { radius, unit } = values;
    const sphereVolume = (4 / 3) * Math.PI * Math.pow(radius, 3);
    setSphereVolume(sphereVolume);
    setConvertedSphereUnit(unit);
  };
  const [coneVolume, setConeVolume] = useState("");
  const [convertedConeUnit, setConvertedConeUnit] = useState("متر");
  const onSubmitCone = (values) => {
    const { baseRadius, height, baseRadiusUnit, heightUnit } = values;
    let convertedBaseRadius = baseRadius;
    let convertedHeight = height;
    if (baseRadiusUnit !== heightUnit) {
      if (conversionMap[baseRadiusUnit] < conversionMap[heightUnit]) {
        convertedBaseRadius =
          (baseRadius * conversionMap[baseRadiusUnit]) /
          conversionMap[heightUnit];
        setConvertedConeUnit(heightUnit);
      } else {
        convertedHeight =
          (height * conversionMap[heightUnit]) / conversionMap[baseRadiusUnit];
        setConvertedConeUnit(baseRadiusUnit);
      }
    } else {
      setConvertedConeUnit(baseRadiusUnit);
    }
    const coneVolume =
      (1 / 3) * Math.PI * Math.pow(convertedBaseRadius, 2) * convertedHeight;
    setConeVolume(coneVolume);
  };
  const [cubeVolume, setCubeVolume] = useState("");
  const [convertedCubeUnit, setConvertedCubeUnit] = useState("متر");
  const onSubmitCube = (values) => {
    const { edge, unit } = values;
    const cubeVolume = Math.pow(edge, 3);
    setCubeVolume(cubeVolume);
    setConvertedCubeUnit(unit);
  };
  const [cylinderVolume, setCylinderVolume] = useState("");
  const [convertedCylinderUnit, setConvertedCylinderUnit] = useState("متر");
  const onSubmitCylinder = (values) => {
    const { baseRadius, height, baseRadiusUnit, heightUnit } = values;
    let convertedBaseRadius = baseRadius;
    let convertedHeight = height;
    if (baseRadiusUnit !== heightUnit) {
      if (conversionMap[baseRadiusUnit] < conversionMap[heightUnit]) {
        convertedBaseRadius =
          (baseRadius * conversionMap[baseRadiusUnit]) /
          conversionMap[heightUnit];
        setConvertedCylinderUnit(heightUnit);
      } else {
        convertedHeight =
          (height * conversionMap[heightUnit]) / conversionMap[baseRadiusUnit];
        setConvertedCylinderUnit(baseRadiusUnit);
      }
    } else {
      setConvertedCylinderUnit(baseRadiusUnit);
    }
    const cylinderVolume =
      Math.PI * Math.pow(convertedBaseRadius, 2) * convertedHeight;
    setCylinderVolume(cylinderVolume);
  };
  const [rectangularVolume, setRectangularVolume] = useState("");
  const [convertedRectangularUnit, setConvertedRectangularUnit] =
    useState("متر");
  const onSubmitRectangular = (values) => {
    const { length, width, height, lengthUnit, widthUnit, heightUnit } = values;
    let convertedLength = length;
    let convertedWidth = width;
    let convertedHeight = height;
    let resultUnit = "";
    if (
      conversionMap[lengthUnit] >= conversionMap[widthUnit] &&
      conversionMap[lengthUnit] >= conversionMap[heightUnit]
    ) {
      resultUnit = lengthUnit;
    } else if (
      conversionMap[widthUnit] >= conversionMap[lengthUnit] &&
      conversionMap[widthUnit] >= conversionMap[heightUnit]
    ) {
      resultUnit = widthUnit;
    } else {
      resultUnit = heightUnit;
    }
    if (resultUnit !== lengthUnit) {
      convertedLength =
        (length * conversionMap[lengthUnit]) / conversionMap[resultUnit];
    }
    if (resultUnit !== widthUnit) {
      convertedWidth =
        (width * conversionMap[widthUnit]) / conversionMap[resultUnit];
    }
    if (resultUnit !== heightUnit) {
      convertedHeight =
        (height * conversionMap[heightUnit]) / conversionMap[resultUnit];
    }
    const rectangularVolume =
      convertedLength * convertedWidth * convertedHeight;
    setRectangularVolume(rectangularVolume);
    setConvertedRectangularUnit(resultUnit);
  };
  const [capsuleVolume, setCapsuleVolume] = useState("");
  const [convertedCapsuleUnit, setConvertedCapsuleUnit] = useState("متر");
  const onSubmitCapsule = (values) => {
    const { baseRadius, height, baseRadiusUnit, heightUnit } = values;
    let convertedBaseRadius = baseRadius;
    let convertedHeight = height;
    let resultUnit = "";
    if (conversionMap[baseRadiusUnit] >= conversionMap[heightUnit]) {
      resultUnit = baseRadiusUnit;
    } else {
      resultUnit = heightUnit;
    }
    if (resultUnit !== baseRadiusUnit) {
      convertedBaseRadius =
        (baseRadius * conversionMap[baseRadiusUnit]) /
        conversionMap[resultUnit];
    }
    if (resultUnit !== heightUnit) {
      convertedHeight =
        (height * conversionMap[heightUnit]) / conversionMap[resultUnit];
    }
    const capsuleVolume =
      (4 / 3) * Math.PI * Math.pow(convertedBaseRadius, 3) +
      Math.PI * Math.pow(convertedBaseRadius, 2) * convertedHeight;
    setCapsuleVolume(capsuleVolume);
    setConvertedCapsuleUnit(resultUnit);
  };
  const [conicalVolume, setConicalVolume] = useState("");
  const [convertedConicalUnit, setConvertedConicalUnit] = useState("متر");
  const onSubmitConical = (values) => {
    const {
      topRadius,
      bottomRadius,
      height,
      topRadiusUnit,
      bottomRadiusUnit,
      heightUnit,
    } = values;
    let convertedTopRadius = topRadius;
    let convertedBottomRadius = bottomRadius;
    let convertedHeight = height;
    let resultUnit = "";
    if (
      conversionMap[topRadiusUnit] >= conversionMap[bottomRadiusUnit] &&
      conversionMap[topRadiusUnit] >= conversionMap[heightUnit]
    ) {
      resultUnit = topRadiusUnit;
    } else if (
      conversionMap[bottomRadiusUnit] >= conversionMap[topRadiusUnit] &&
      conversionMap[bottomRadiusUnit] >= conversionMap[heightUnit]
    ) {
      resultUnit = bottomRadiusUnit;
    } else {
      resultUnit = heightUnit;
    }
    if (resultUnit !== topRadiusUnit) {
      convertedTopRadius =
        (topRadius * conversionMap[topRadiusUnit]) / conversionMap[resultUnit];
    }
    if (resultUnit !== bottomRadiusUnit) {
      convertedBottomRadius =
        (bottomRadius * conversionMap[bottomRadiusUnit]) /
        conversionMap[resultUnit];
    }
    if (resultUnit !== heightUnit) {
      convertedHeight =
        (height * conversionMap[heightUnit]) / conversionMap[resultUnit];
    }
    const conicalVolume =
      (1 / 3) *
      Math.PI *
      convertedHeight *
      (Math.pow(convertedTopRadius, 2) +
        Math.pow(convertedBottomRadius, 2) +
        convertedTopRadius * convertedBottomRadius);
    setConicalVolume(conicalVolume);
    setConvertedConicalUnit(resultUnit);
  };
  const [ellipsoidVolume, setEllipsoidVolume] = useState("");
  const [convertedEllipsoidUnit, setConvertedEllipsoidUnit] = useState("متر");
  const onSubmitEllipsoid = (values) => {
    const { axis1, axis2, axis3, axis1Unit, axis2Unit, axis3Unit } = values;
    let convertedAxis1 = axis1;
    let convertedAxis2 = axis2;
    let convertedAxis3 = axis3;
    let resultUnit = "";
    if (
      conversionMap[axis1Unit] >= conversionMap[axis2Unit] &&
      conversionMap[axis1Unit] >= conversionMap[axis3Unit]
    ) {
      resultUnit = axis1Unit;
    } else if (
      conversionMap[axis2Unit] >= conversionMap[axis1Unit] &&
      conversionMap[axis2Unit] >= conversionMap[axis3Unit]
    ) {
      resultUnit = axis2Unit;
    } else {
      resultUnit = axis3Unit;
    }
    if (resultUnit !== axis1Unit) {
      convertedAxis1 =
        (axis1 * conversionMap[axis1Unit]) / conversionMap[resultUnit];
    }
    if (resultUnit !== axis2Unit) {
      convertedAxis2 =
        (axis2 * conversionMap[axis2Unit]) / conversionMap[resultUnit];
    }
    if (resultUnit !== axis3Unit) {
      convertedAxis3 =
        (axis3 * conversionMap[axis3Unit]) / conversionMap[resultUnit];
    }
    const ellipsoidVolume =
      (4 / 3) * Math.PI * convertedAxis1 * convertedAxis2 * convertedAxis3;
    setEllipsoidVolume(ellipsoidVolume);
    setConvertedEllipsoidUnit(resultUnit);
  };
  const [pyramidVolume, setPyramidVolume] = useState("");
  const [convertedPyramidUnit, setConvertedPyramidUnit] = useState("متر");
  const onSubmitPyramid = (values) => {
    const { baseEdge, height, baseEdgeUnit, heightUnit } = values;
    let convertedBaseEdge = baseEdge;
    let convertedHeight = height;
    let resultUnit = "";
    if (conversionMap[baseEdgeUnit] >= conversionMap[heightUnit]) {
      resultUnit = baseEdgeUnit;
    } else {
      resultUnit = heightUnit;
    }
    if (resultUnit !== baseEdgeUnit) {
      convertedBaseEdge =
        (baseEdge * conversionMap[baseEdgeUnit]) / conversionMap[resultUnit];
    }
    if (resultUnit !== heightUnit) {
      convertedHeight =
        (height * conversionMap[heightUnit]) / conversionMap[resultUnit];
    }
    const pyramidVolume =
      (1 / 3) * Math.pow(convertedBaseEdge, 2) * convertedHeight;
    setPyramidVolume(pyramidVolume);
    setConvertedPyramidUnit(resultUnit);
  };
  const [tubeVolume, setTubeVolume] = useState("");
  const [convertedTubeUnit, setConvertedTubeUnit] = useState("متر");
  const [errorDiameter, setErrorDiameter] = useState("");
  const onSubmitTube = (values) => {
    const {
      outerDiameter,
      innerDiameter,
      length,
      outerDiameterUnit,
      innerDiameterUnit,
      lengthUnit,
    } = values;
    let convertedOuterDiameter = outerDiameter;
    let convertedInnerDiameter = innerDiameter;
    let convertedLength = length;
    let resultUnit = "";
    if (
      conversionMap[outerDiameterUnit] >= conversionMap[innerDiameterUnit] &&
      conversionMap[outerDiameterUnit] >= conversionMap[lengthUnit]
    ) {
      resultUnit = outerDiameterUnit;
    } else if (
      conversionMap[innerDiameterUnit] >= conversionMap[outerDiameterUnit] &&
      conversionMap[innerDiameterUnit] >= conversionMap[lengthUnit]
    ) {
      resultUnit = innerDiameterUnit;
    } else {
      resultUnit = lengthUnit;
    }
    if (resultUnit !== outerDiameterUnit) {
      convertedOuterDiameter =
        (outerDiameter * conversionMap[outerDiameterUnit]) /
        conversionMap[resultUnit];
    }
    if (resultUnit !== innerDiameterUnit) {
      convertedInnerDiameter =
        (innerDiameter * conversionMap[innerDiameterUnit]) /
        conversionMap[resultUnit];
    }
    if (resultUnit !== lengthUnit) {
      convertedLength =
        (length * conversionMap[lengthUnit]) / conversionMap[resultUnit];
    }
    if (convertedOuterDiameter < convertedInnerDiameter) {
      setErrorDiameter(
        "رجاءا تأكد ان قيمة القطر الداخلي يجب ان تكون اصغر من قيمة القطر الخارجي"
      );
    } else {
      setErrorDiameter("");
    }
    const tubeVolume = (
      Math.PI *
      ((Math.pow(convertedOuterDiameter, 2) -
        Math.pow(convertedInnerDiameter, 2)) /
        4) *
      convertedLength
    ).toFixed(2);
    setTubeVolume(tubeVolume);
    setConvertedTubeUnit(resultUnit);
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="row">
            <div>
              <p>
                حاسبة حجوم الأشكال الهندسية تُحسب حجوم جميع الأشكال الشائعة بما
                في ذلك الكرة، المخروط، المكعب، الأسطوانة، الكبسولة، الغطاء،
                الجذع المخروطي، الشكل البيضوي، الهرم، الانبوب والمزيد.
              </p>
              <h2 style={{ fontSize: "17px" }}>
                يتم حساب حجوم الأشكال الهندسية بالطريقة التالية
              </h2>
              <ul>
                <li>
                  حجم مجال جسم كروي : 4/3 ضرب π ضرب نصف القطر مرفوع للتكعيب
                </li>
                <li>
                  حجم المخروط : 1/3 ضرب π ضرب نصف القطر مرفوع للتربيع ضرب
                  الارتفاع
                </li>
                <li>حجم المكعب : الضلع مرفوع للتكعيب</li>
                <li>
                  حجم الأسطوانة : π ضرب نصف القطر مرفوع للتربيع ضرب الارتفاع
                </li>
                <li>حجم خزان المستطيل : نضرب الطول بالعرض بالارتفاع</li>
                <li>
                  حجم الكبسولة : 4/3 ضرب π ضرب نصف القطر الأساسي مرفوع للتكعيب +
                  π ضرب نصف القطر الأساسي مرفوع للتربيع ضرب الارتفاع
                </li>
                <li>
                  حجم القطعة المخروطية : 1/3 ضرب π ضرب الارتفاع ضرب (نصف قطر
                  القاعدة العليا مرفوعة للتربيع +(نصف قطر القاعدة العليا ضرب نصف
                  قطر القاعدة السفلى) + نصف قطر القاعدة السفلى مرفوعة للتربيع )
                </li>
                <li>حجم الشكل البيضوي : 4/3 ضرب π ضرب a ضرب b ضرب c</li>
                <li>
                  حجم الهرم : 1/3 ضرب حد القاعدة مرفوع للتربيع ضرب الارتفاع
                </li>
                <li>
                  حجم الانبوب : π ضرب (قطر الانبوب الخارجي مرفوع للتربيع - قطر
                  الانبوب الداخلي مرفوع للتربيع)/4 ضرب 4
                </li>
              </ul>
              <b>
                يمكنك أيضا استخدم الحاسبة التالية لإيجاد حجوم الأشكال الهندسية :
              </b>
              <hr />
            </div>
          </div>
          <MobileUnderCalAds />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <Formik
                initialValues={initialSphereValues}
                validationSchema={sphereSchema}
                onSubmit={onSubmitSphere}
              >
                {(formik) => (
                  <Form>
                    <div className="mb-3">
                      <h3
                        className="p-3 mb-2 bg-success text-white"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        حساب حجم الكرة - حاسبة حجم الكرة
                      </h3>
                      <TextField
                        label="القطر"
                        name="radius"
                        value={formik.values.radius}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.radius && formik.errors.radius}
                        helperText={
                          formik.touched.radius && formik.errors.radius
                        }
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="unit"
                        value={formik.values.unit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <Button
                        type="submit"
                        disabled={!formik.isValid}
                        color="success"
                        sx={{
                          backgroundColor: "rgb(25,135,84)",
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                          color: "white",
                        }}
                      >
                        إحسب
                      </Button>
                      <Button
                        disabled={!formik.isValid}
                        sx={sharedSxClear}
                        onClick={() => {
                          setSphereVolume(null);
                          formik.resetForm();
                        }}
                      >
                        امسح النتيجة
                      </Button>
                    </div>
                    {sphereVolume && sphereVolume > 0 ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          النتيجة : حجم الجسم الكروي هو : {sphereVolume}{" "}
                          {convertedSphereUnit}
                          <sup>3</sup>
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </Form>
                )}
              </Formik>
            </div>
            <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
              <img
                loading="lazy"
                alt="حساب حجم الجسم الكروي"
                src={sphereimg}
                style={{ width: "75px", height: "75px" }}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <Formik
                initialValues={initialConeValues}
                validationSchema={coneSchema}
                onSubmit={onSubmitCone}
              >
                {(formik) => (
                  <Form>
                    <div className="mb-3">
                      <h3
                        className="p-3 mb-2 bg-success text-white"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        حساب حجم المخروط - حاسبة حجم المخروط
                      </h3>
                      <TextField
                        label="قطر القاعدة"
                        name="baseRadius"
                        value={formik.values.baseRadius}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.baseRadius && formik.errors.baseRadius
                        }
                        helperText={
                          formik.touched.baseRadius && formik.errors.baseRadius
                        }
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="baseRadiusUnit"
                        value={formik.values.baseRadiusUnit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <TextField
                        label="الطول"
                        name="height"
                        value={formik.values.height}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.height && formik.errors.height}
                        helperText={
                          formik.touched.height && formik.errors.height
                        }
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="heightUnit"
                        value={formik.values.heightUnit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <Button
                        type="submit"
                        disabled={!formik.isValid}
                        color="success"
                        sx={{
                          backgroundColor: "rgb(25,135,84)",
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                          color: "white",
                        }}
                      >
                        إحسب
                      </Button>
                      <Button
                        disabled={!formik.isValid}
                        sx={sharedSxClear}
                        onClick={() => {
                          setConeVolume(null);
                          formik.resetForm();
                        }}
                      >
                        امسح النتيجة
                      </Button>
                    </div>
                    {coneVolume && coneVolume > 0 ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          النتيجة : حجم المخروط هو : {coneVolume}{" "}
                          {convertedConeUnit}
                          <sup>3</sup>
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </Form>
                )}
              </Formik>
            </div>
            <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
              <img
                loading="lazy"
                alt="حساب حجم المخروط"
                src={coneimg}
                style={{ width: "75px", height: "75px" }}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <Formik
                initialValues={initialCubeValues}
                validationSchema={cubeSchema}
                onSubmit={onSubmitCube}
              >
                {(formik) => (
                  <Form>
                    <div className="mb-3">
                      <h3
                        className="p-3 mb-2 bg-success text-white"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        حساب حجم المكعب - حاسبة حجم المكعب
                      </h3>
                      <TextField
                        label="طول الحافة"
                        name="edge"
                        value={formik.values.edge}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.edge && formik.errors.edge}
                        helperText={formik.touched.edge && formik.errors.edge}
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="unit"
                        value={formik.values.unit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <Button
                        type="submit"
                        disabled={!formik.isValid}
                        color="success"
                        sx={{
                          backgroundColor: "rgb(25,135,84)",
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                          color: "white",
                        }}
                      >
                        إحسب
                      </Button>
                      <Button
                        disabled={!formik.isValid}
                        sx={sharedSxClear}
                        onClick={() => {
                          setCubeVolume(null);
                          formik.resetForm();
                        }}
                      >
                        امسح النتيجة
                      </Button>
                    </div>
                    {cubeVolume && cubeVolume > 0 ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          النتيجة : حجم المكعب هو : {cubeVolume}{" "}
                          {convertedCubeUnit}
                          <sup>3</sup>
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </Form>
                )}
              </Formik>
            </div>
            <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
              <img
                loading="lazy"
                alt="حساب حجم المكعب"
                src={cube}
                style={{ width: "75px", height: "75px" }}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <Formik
                initialValues={initialCylinderValues}
                validationSchema={cylinderSchema}
                onSubmit={onSubmitCylinder}
              >
                {(formik) => (
                  <Form>
                    <div className="mb-3">
                      <h3
                        className="p-3 mb-2 bg-success text-white"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        حساب حجم الأسطوانة - حاسبة حجم الأسطوانة
                      </h3>
                      <TextField
                        label="قطر القاعدة"
                        name="baseRadius"
                        value={formik.values.baseRadius}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.baseRadius && formik.errors.baseRadius
                        }
                        helperText={
                          formik.touched.baseRadius && formik.errors.baseRadius
                        }
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="baseRadiusUnit"
                        value={formik.values.baseRadiusUnit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <TextField
                        label="الطول"
                        name="height"
                        value={formik.values.height}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.height && formik.errors.height}
                        helperText={
                          formik.touched.height && formik.errors.height
                        }
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="heightUnit"
                        value={formik.values.heightUnit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <Button
                        type="submit"
                        disabled={!formik.isValid}
                        color="success"
                        sx={{
                          backgroundColor: "rgb(25,135,84)",
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                          color: "white",
                        }}
                      >
                        إحسب
                      </Button>
                      <Button
                        disabled={!formik.isValid}
                        sx={sharedSxClear}
                        onClick={() => {
                          setCylinderVolume(null);
                          formik.resetForm();
                        }}
                      >
                        امسح النتيجة
                      </Button>
                    </div>
                    {cylinderVolume && cylinderVolume > 0 ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          النتيجة : حجم الأسطوانة هو : {cylinderVolume}{" "}
                          {convertedCylinderUnit}
                          <sup>3</sup>
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </Form>
                )}
              </Formik>
            </div>
            <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
              <img
                loading="lazy"
                alt="حساب حجم الأسطوانة"
                src={cylinderimg}
                style={{ width: "75px", height: "75px" }}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <Formik
                initialValues={initialRectangularValues}
                validationSchema={rectangularSchema}
                onSubmit={onSubmitRectangular}
              >
                {(formik) => (
                  <Form>
                    <div className="mb-3">
                      <h3
                        className="p-3 mb-2 bg-success text-white"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        حساب حجم خزان المستطيل - حاسبة حجم خزان المستطيل
                      </h3>
                      <TextField
                        label="الطول"
                        name="length"
                        value={formik.values.length}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.length && formik.errors.length}
                        helperText={
                          formik.touched.length && formik.errors.length
                        }
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="lengthUnit"
                        value={formik.values.lengthUnit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <TextField
                        label="العرض"
                        name="width"
                        value={formik.values.width}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.width && formik.errors.width}
                        helperText={formik.touched.width && formik.errors.width}
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="widthUnit"
                        value={formik.values.widthUnit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <TextField
                        label="الطول"
                        name="height"
                        value={formik.values.height}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.height && formik.errors.height}
                        helperText={
                          formik.touched.height && formik.errors.height
                        }
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="heightUnit"
                        value={formik.values.heightUnit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <Button
                        type="submit"
                        disabled={!formik.isValid}
                        color="success"
                        sx={{
                          backgroundColor: "rgb(25,135,84)",
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                          color: "white",
                        }}
                      >
                        إحسب
                      </Button>
                      <Button
                        disabled={!formik.isValid}
                        sx={sharedSxClear}
                        onClick={() => {
                          setRectangularVolume(null);
                          formik.resetForm();
                        }}
                      >
                        امسح النتيجة
                      </Button>
                    </div>
                    {rectangularVolume && rectangularVolume > 0 ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          النتيجة : حجم المستطيل هو : {rectangularVolume}{" "}
                          {convertedRectangularUnit}
                          <sup>3</sup>
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </Form>
                )}
              </Formik>
            </div>
            <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
              <img
                loading="lazy"
                alt="حسم حجم الخزان المستطيل"
                src={rectangularimg}
                style={{ width: "75px", height: "75px" }}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <Formik
                initialValues={initialCapsuleValues}
                validationSchema={capsuleSchema}
                onSubmit={onSubmitCapsule}
              >
                {(formik) => (
                  <Form>
                    <div className="mb-3">
                      <h3
                        className="p-3 mb-2 bg-success text-white"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        حساب حجم الكبسولة - حاسبة حجم الكبسولة
                      </h3>
                      <TextField
                        label="قطر القاعدة"
                        name="baseRadius"
                        value={formik.values.baseRadius}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.baseRadius && formik.errors.baseRadius
                        }
                        helperText={
                          formik.touched.baseRadius && formik.errors.baseRadius
                        }
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="baseRadiusUnit"
                        value={formik.values.baseRadiusUnit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <TextField
                        label="الطول"
                        name="height"
                        value={formik.values.height}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.height && formik.errors.height}
                        helperText={
                          formik.touched.height && formik.errors.height
                        }
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="heightUnit"
                        value={formik.values.heightUnit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <Button
                        type="submit"
                        disabled={!formik.isValid}
                        color="success"
                        sx={{
                          backgroundColor: "rgb(25,135,84)",
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                          color: "white",
                        }}
                      >
                        إحسب
                      </Button>
                      <Button
                        disabled={!formik.isValid}
                        sx={sharedSxClear}
                        onClick={() => {
                          setCapsuleVolume(null);
                          formik.resetForm();
                        }}
                      >
                        امسح النتيجة
                      </Button>
                    </div>
                    {capsuleVolume && capsuleVolume > 0 ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          النتيجة : حجم الكبسولة هو : {capsuleVolume}{" "}
                          {convertedCapsuleUnit}
                          <sup>3</sup>
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </Form>
                )}
              </Formik>
            </div>
            <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
              <img
                loading="lazy"
                alt="حساب حجم الكبسولة"
                src={capsuleimg}
                style={{ width: "75px", height: "75px" }}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <Formik
                initialValues={initialConicalValues}
                validationSchema={conicalSchema}
                onSubmit={onSubmitConical}
              >
                {(formik) => (
                  <Form>
                    <div className="mb-3">
                      <h3
                        className="p-3 mb-2 bg-success text-white"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        حساب حجم الجذع المخروطية - حاسبة حجم الجذع المخروطية
                      </h3>
                      <TextField
                        label="القطر العلوي"
                        name="topRadius"
                        value={formik.values.topRadius}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.topRadius && formik.errors.topRadius
                        }
                        helperText={
                          formik.touched.topRadius && formik.errors.topRadius
                        }
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="topRadiusUnit"
                        value={formik.values.topRadiusUnit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <TextField
                        label="القطر السفلي"
                        name="bottomRadius"
                        value={formik.values.bottomRadius}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.bottomRadius &&
                          formik.errors.bottomRadius
                        }
                        helperText={
                          formik.touched.bottomRadius &&
                          formik.errors.bottomRadius
                        }
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="bottomRadiusUnit"
                        value={formik.values.bottomRadiusUnit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <TextField
                        label="الطول"
                        name="height"
                        value={formik.values.height}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.height && formik.errors.height}
                        helperText={
                          formik.touched.height && formik.errors.height
                        }
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="heightUnit"
                        value={formik.values.heightUnit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <Button
                        type="submit"
                        disabled={!formik.isValid}
                        color="success"
                        sx={{
                          backgroundColor: "rgb(25,135,84)",
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                          color: "white",
                        }}
                      >
                        إحسب
                      </Button>
                      <Button
                        disabled={!formik.isValid}
                        sx={sharedSxClear}
                        onClick={() => {
                          setConicalVolume(null);
                          formik.resetForm();
                        }}
                      >
                        امسح النتيجة
                      </Button>
                    </div>
                    {conicalVolume && conicalVolume > 0 ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          النتيجة : حجم المخروط هو : {conicalVolume}{" "}
                          {convertedConicalUnit}
                          <sup>3</sup>
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </Form>
                )}
              </Formik>
            </div>
            <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
              <img
                loading="lazy"
                alt="حساب حجم الجذع المخروطية"
                src={conicalimg}
                style={{ width: "75px", height: "75px" }}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <Formik
                initialValues={initialEllipsoidValues}
                validationSchema={ellipsoidSchema}
                onSubmit={onSubmitEllipsoid}
              >
                {(formik) => (
                  <Form>
                    <div className="mb-3">
                      <h3
                        className="p-3 mb-2 bg-success text-white"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        حساب حجم الشكل البيضوي - حاسبة حجم الشكل البيضوي
                      </h3>
                      <TextField
                        label="محور 1"
                        name="axis1"
                        value={formik.values.axis1}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.axis1 && formik.errors.axis1}
                        helperText={formik.touched.axis1 && formik.errors.axis1}
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="axis1Unit"
                        value={formik.values.axis1Unit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <TextField
                        label="محور 2"
                        name="axis2"
                        value={formik.values.axis2}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.axis2 && formik.errors.axis2}
                        helperText={formik.touched.axis2 && formik.errors.axis2}
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="axis2Unit"
                        value={formik.values.axis2Unit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <TextField
                        label="محور 3"
                        name="axis3"
                        value={formik.values.axis3}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.axis3 && formik.errors.axis3}
                        helperText={formik.touched.axis3 && formik.errors.axis3}
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="axis3Unit"
                        value={formik.values.axis3Unit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <Button
                        type="submit"
                        disabled={!formik.isValid}
                        color="success"
                        sx={{
                          backgroundColor: "rgb(25,135,84)",
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                          color: "white",
                        }}
                      >
                        إحسب
                      </Button>
                      <Button
                        disabled={!formik.isValid}
                        sx={sharedSxClear}
                        onClick={() => {
                          setEllipsoidVolume(null);
                          formik.resetForm();
                        }}
                      >
                        امسح النتيجة
                      </Button>
                    </div>
                    {ellipsoidVolume && ellipsoidVolume > 0 ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          النتيجة : حجم الشكل البيضوي هو : {ellipsoidVolume}{" "}
                          {convertedEllipsoidUnit}
                          <sup>3</sup>
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </Form>
                )}
              </Formik>
            </div>
            <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
              <img
                loading="lazy"
                alt="حساب حجم الشكل البيضوي"
                src={ellipsoidimg}
                style={{ width: "75px", height: "75px" }}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <Formik
                initialValues={initialPyramidValues}
                validationSchema={pyramidSchema}
                onSubmit={onSubmitPyramid}
              >
                {(formik) => (
                  <Form>
                    <div className="mb-3">
                      <h3
                        className="p-3 mb-2 bg-success text-white"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        حساب حجم الهرم - حاسبة حجم الهرم
                      </h3>
                      <TextField
                        label="حافة القاعدة"
                        name="baseEdge"
                        value={formik.values.baseEdge}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.baseEdge && formik.errors.baseEdge
                        }
                        helperText={
                          formik.touched.baseEdge && formik.errors.baseEdge
                        }
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="baseEdgeUnit"
                        value={formik.values.baseEdgeUnit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <TextField
                        label="الطول"
                        name="height"
                        value={formik.values.height}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.height && formik.errors.height}
                        helperText={
                          formik.touched.height && formik.errors.height
                        }
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="heightUnit"
                        value={formik.values.heightUnit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <Button
                        type="submit"
                        disabled={!formik.isValid}
                        color="success"
                        sx={{
                          backgroundColor: "rgb(25,135,84)",
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                          color: "white",
                        }}
                      >
                        إحسب
                      </Button>
                      <Button
                        disabled={!formik.isValid}
                        sx={sharedSxClear}
                        onClick={() => {
                          setPyramidVolume(null);
                          formik.resetForm();
                        }}
                      >
                        امسح النتيجة
                      </Button>
                    </div>
                    {pyramidVolume && pyramidVolume > 0 ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          النتيجة : حجم الهرم هو : {pyramidVolume}{" "}
                          {convertedPyramidUnit}
                          <sup>3</sup>
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </Form>
                )}
              </Formik>
            </div>
            <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
              <img
                loading="lazy"
                alt="حساب حجم الهرم"
                src={pyramidimg}
                style={{ width: "75px", height: "75px" }}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-12 col-md-7 calculatorStyle">
              <Formik
                initialValues={initialTubeValues}
                validationSchema={tubeSchema}
                onSubmit={onSubmitTube}
              >
                {(formik) => (
                  <Form>
                    <div className="mb-3">
                      <h3
                        className="p-3 mb-2 bg-success text-white"
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        حاسبة حجم الانبوب - حساب حجم الانبوب
                      </h3>
                      <TextField
                        label="القطر الخارجي"
                        name="outerDiameter"
                        value={formik.values.outerDiameter}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.outerDiameter &&
                          formik.errors.outerDiameter
                        }
                        helperText={
                          formik.touched.outerDiameter &&
                          formik.errors.outerDiameter
                        }
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="outerDiameterUnit"
                        value={formik.values.outerDiameterUnit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <TextField
                        label="القطر الداخلي"
                        name="innerDiameter"
                        value={formik.values.innerDiameter}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.innerDiameter &&
                          formik.errors.innerDiameter
                        }
                        helperText={
                          formik.touched.innerDiameter &&
                          formik.errors.innerDiameter
                        }
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="innerDiameterUnit"
                        value={formik.values.innerDiameterUnit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <TextField
                        label="الطول"
                        name="length"
                        value={formik.values.length}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.length && formik.errors.length}
                        helperText={
                          formik.touched.length && formik.errors.length
                        }
                        sx={{
                          sharedSmStyle
                        }}
                        size="small"
                        color="success"
                      />
                      <Field
                        as={TextField}
                        select
                        name="lengthUnit"
                        value={formik.values.lengthUnit}
                        onChange={formik.handleChange}
                        size="small"
                        style={{
                          backgroundColor: "#f9f9f9",
                          pending: "5px",
                        }}
                      >
                        {Object.keys(conversionMap).map((unit) => (
                          <MenuItem key={unit} value={unit}>
                            {unit}
                          </MenuItem>
                        ))}
                      </Field>
                    </div>
                    <div className="mb-3">
                      <Button
                        type="submit"
                        disabled={!formik.isValid}
                        color="success"
                        sx={{
                          backgroundColor: "rgb(25,135,84)",
                          fontSize: "15px",
                          marginRight: "25px",
                          padding: "5px 25px",
                          color: "white",
                        }}
                      >
                        إحسب
                      </Button>
                      <Button
                        disabled={!formik.isValid}
                        sx={sharedSxClear}
                        onClick={() => {
                          setTubeVolume(null);
                          formik.resetForm();
                          setErrorDiameter("");
                        }}
                      >
                        امسح النتيجة
                      </Button>
                    </div>
                    {errorDiameter && (
                      <p className="p-3 mb-2 bg-danger text-white">
                        {errorDiameter}
                      </p>
                    )}
                    {tubeVolume && tubeVolume > 0 ? (
                      <Fragment>
                        <p className="p-3 mb-2 bg-success text-white">
                          النتيجة : حجم الانبوب هو : {tubeVolume}{" "}
                          {convertedTubeUnit}
                          <sup>3</sup>
                        </p>
                      </Fragment>
                    ) : (
                      ""
                    )}
                  </Form>
                )}
              </Formik>
            </div>
            <div className="col-sm-12 col-md-4 mt-md-5 mt-3 text-center">
              <img
                loading="lazy"
                alt="حساب حجم الانبوب"
                src={tubeimg}
                style={{ width: "75px", height: "75px" }}
              />
            </div>
          </div>
          <hr />
          <div className="row">
            <RelatedLinks />
            <hr />
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    حجم الاشكال الهندسية والرياضية
                  </h2>{" "}
                </u>{" "}
              </div>
              <div className="info-section-body">
                <p>
                  الحجم هو تقدير للمساحة الثلاثية الأبعاد التي يشغلها جسم مادي.
                  وحدة النظام الدولي للحجم هي المتر المكعب، أو m3. من خلال
                  التقليد، يُفضل أن يكون حجم الحاوية عادة هو سعتها، وكمية السائل
                  التي يمكن أن تحتويها، بدلاً من كمية المساحة التي يشغلها
                  الحاوية الفعلية. يمكن حساب حجوم العديد من الأشكال باستخدام صيغ
                  معرفة بشكل جيد. في بعض الحالات، يمكن تفكيك أشكال أكثر تعقيدًا
                  إلى أشكال مجتمعة أبسط، ويتم استخدام مجموع حجومها لتحديد الحجم
                  الإجمالي. يمكن حساب حجوم أشكال أخرى أكثر تعقيدًا باستخدام حساب
                  التفاضل والتكامل إذا كانت هناك صيغة معروفة لحدود الشكل. وراء
                  ذلك، يمكن تقدير حجوم الأشكال التي لا يمكن وصفها بمعادلات
                  معروفة باستخدام الأساليب الرياضية، مثل طريقة العنصر النهائي.
                  بديلًا لذلك، إذا كان يعرف كثافة مادة ما، وكانت متجانسة، يمكن
                  حساب الحجم باستخدام وزنها. تقوم هذه الآلة الحاسبة بحساب الحجوم
                  لبعض أكثر الأشكال البسيطة شيوعًا.
                </p>
                <br />
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <u>
                  <h3 style={{ fontSize: "16px" }}>
                    {" "}
                    حساب حجم الكرة - حاسبة حجم الكرة
                  </h3>{" "}
                </u>{" "}
              </div>
              <div className="info-section-body">
                <p>
                  الكرة هي كائن هندسي ثلاثي الأبعاد يشبه دائرة ثنائية الأبعاد.
                  إنها هيكل هندسي دائري تمامًا، رياضيًا، وهي مجموعة من النقاط
                  التي تبعد بالمسافة نفسها عن نقطة مركزية، حيث يكون النصف القطري
                  r هو المسافة بين النقطة المركزية وأي نقطة على الكرة. على الرغم
                  من أن الكرة تشمل الفهم الشائع للكرة المستديرة، فإنها تمثل بشكل
                  دقيق الشكل الهندسي.
                </p>
                <p>
                  كما هو الحال في الدائرة، يُشير القطر d إلى الخط الذي يربط
                  نقطتين على الكرة من خلال مركزها، وهو أطول قطعة خط. يمكن حساب
                  حجم الكرة باستخدام المعادلة التالية:
                </p>
                <p>حجم = 4/3 × π × r³</p>
                <p>
                  مثال: ترغب دينا في ملء بالونة مائية كروية تمامًا بنصف قطرها
                  0.15 قدم بزيت الزيتون واستخدامها في معركة البالونات المائية ضد
                  صديقتها المقربة سمية في نهاية هذا الأسبوع. يمكن حساب حجم زيت
                  الزيتون المطلوب باستخدام المعادلة المقدمة أدناه:
                </p>
                <p>حجم = 4/3 × π × (0.15)³ = 0.141 قدم³</p>
                <br />
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <u>
                  <h3 style={{ fontSize: "16px" }}>
                    {" "}
                    حساب حجم المخروط - حاسبة حجم المخروط
                  </h3>{" "}
                </u>{" "}
              </div>
              <div className="info-section-body">
                <p>
                  المخروط هو شكل ثلاثي الأبعاد يتضاغط بسلاسة من قاعدته الدائرية
                  عادةً إلى نقطة مشتركة تُسمى القمة (أو الفتحة). رياضيًا، يتم
                  تشكيل المخروط بطريقة مشابهة للدائرة، عن طريق مجموعة من الخطوط
                  المتصلة بنقطة مشتركة، باستثناء أن نقطة المركز لا تُشمل في
                  المستوى الذي يحتوي على الدائرة (أو قاعدة أخرى). يُعتبر هنا فقط
                  المخروط الدائري الحق النهائي المحدود. لن يتم التطرق هنا إلى
                  المخروطات المكونة من نصف خطوط، قواعد غير دائرية، إلخ، التي
                  تمتد إلى ما لا نهاية. المعادلة لحساب حجم المخروط هي كما يلي:
                </p>
                <p>حجم = 1/3 × π × r² × h</p>
                <p>حيث r هو نصف قطر القاعدة و h هو الارتفاع للمخروط</p>
                <p>
                  مثال: لينا عازمة على خروج من محل الآيس كريم بـ 5 دولارات حصلت
                  عليها بجدارة. على الرغم من تفضيلها للبسكويت العادي، إلا أن
                  المخروطات اللذيذة بالوافل لا شك في أنها أكبر بكثير. تقرر أن
                  لديها تفضيلًا بنسبة 15٪ للمخروطات اللذيذة بالوافل أكثر من
                  المخروطات العادية وتحتاج إلى حساب ما إذا كان حجم المخروط
                  اللذيذ بالوافل يزيد عن 15٪ من حجم المخروط العادي. يمكن حساب
                  حجم المخروط اللذيذ بقاعدة دائرية ونصف قطر 1.5 بوصة وارتفاع 5
                  بوصات باستخدام المعادلة أدناه:
                </p>
                <p>حجم = 1/3 × π × 1.5² × 5 = 11.781 بوصة³</p>
                <p>
                  لينا تحسب أيضًا حجم المخروط العادي وتجد أن الفارق أقل من 15٪،
                  وتقرر شراء المخروط العادي. الآن كل ما عليها فعله هو استخدام
                  سحرها وجاذبيتها لإقناع الموظفين بتفريغ حاويات الآيس كريم في
                  مخروطها.
                </p>
                <br />
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <u>
                  <h3 style={{ fontSize: "16px" }}>
                    {" "}
                    حساب حجم المكعب - حاسبة حجم المكعب
                  </h3>{" "}
                </u>{" "}
              </div>
              <div className="info-section-body">
                <p>
                  المكعب هو النظير ثلاثي الأبعاد للمربع، وهو جسم محدود بست وجوه
                  مربعة، حيث تلتقي ثلاث منها في كل ركن، وكلها متعامدة على وجوهها
                  المتجاورة. يُعتبر المكعب حالة خاصة في العديد من تصنيفات
                  الأشكال في الهندسة، بما في ذلك كونه متوازياً مستطيلياً، ومكعب
                  ذو وجوه متساوية، ومكعب رومبويديًا صحيحًا. فيما يلي المعادلة
                  لحساب حجم المكعب:
                </p>
                <p>حجم = a³</p>
                <p>حيث a هو طول حافة المكعب.</p>
                <p>
                  مثال: ليلى، التي وُلدت في ألاسكا (وتحلم بزيارة الشمس لمرة
                  واحدة)، قررت زيارة موطنها الأم في هاواي. ساحرة بجمال الطبيعة
                  الهاواية، قررت ليلى أن تأتي بجزء من هذا الجمال إلى منزلها.
                  ليلى تحمل حقيبة سفر مكعبة بأضلاع طولها 3 أقدام، وتحسب حجم
                  التربة التي يمكنها حملها معها بالطريقة التالية:
                </p>
                <p>حجم = 3³ = 27 قدم³</p>
                <br />
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <u>
                  <h3 style={{ fontSize: "16px" }}>
                    {" "}
                    حساب حجم الأسطوانة - حاسبة حجم الأسطوانة
                  </h3>{" "}
                </u>{" "}
              </div>
              <div className="info-section-body">
                <p>
                  الأسطوانة في تصميمها الأبسط تُعرف كسطح يتكون من نقاط على مسافة
                  ثابتة من محور خط معين. في استخدامها الشائع، يشير مصطلح
                  "أسطوانة" عادةً إلى أسطوانة دائرية صحيحة، حيث تكون قواعدها
                  دوائر متصلة عبر مراكزها بمحور يتعامد على أسطح قواعدها، بارتفاع
                  معين h ونصف قطر r. المعادلة لحساب حجم الأسطوانة تظهر أدناه:
                </p>
                <p>حجم = πr²h</p>
                <p>حيث r هو نصف القطر و h هو ارتفاع الأسطوانة.</p>
                <p>
                  مثال: يرغب زكريا في إنشاء قلعة رملية في غرفة معيشته، وبما أنه
                  مؤيد قوي للبيئة، استعاد ثلاثة براميل أسطوانية من موقع تخلص غير
                  قانوني وقام بتنظيفها من المواد الكيميائية باستخدام مسحوق
                  الصحون والماء. تحمل هذه البراميل نصف قطر 3 قدم وارتفاع 4 قدم،
                  ويقوم زكريا بحساب حجم الرمل الذي يمكن أن تستوعبه كل برميل
                  باستخدام المعادلة أدناه:
                </p>
                <p>حجم = π × 3² × 4 = 113.097 قدم³</p>
                <p>
                  نجح في بناء قلعة رملية رائعة في منزله، وكمكافأة إضافية، نجح في
                  توفير الكهرباء في إضاءة الليل، حيث تتألق قلعته الرملية بلون
                  أخضر فاتح في الظلام.
                </p>
                <br />
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <u>
                  <h3 style={{ fontSize: "16px" }}>
                    {" "}
                    حساب حجم الخزان المستطيل - حاسبة حجم الخزان المستطيل
                  </h3>{" "}
                </u>{" "}
              </div>
              <div className="info-section-body">
                <p>
                  الصهريج المستطيل هو تشكيلة عامة للمكعب، حيث يمكن أن تكون
                  الأضلاع ذات طول متفاوت. يحده ست وجوه، حيث تلتقي ثلاث منها في
                  رؤوسه، وكلها متعامدة على وجوهها المتجاورة. المعادلة لحساب حجم
                  المستطيل تظهر أدناه:
                </p>
                <p>حجم = الطول × العرض × الارتفاع</p>
                <p>
                  مثال: ليلى تحب الكيك. تقوم بزيارة النادي الرياضي لمدة 4 ساعات
                  يوميًا، كل يوم، لتعويض حبها للكيك. تخطط للقيام برحلة تسلق في
                  جبل كالالاو في كاواي، ورغم أنها في حالة بدنية ممتازة، إلا أن
                  ليلى تشعر بالقلق بسبب عدم وجود كيك. تقرر أن تحزم فقط الضروريات
                  وترغب في ملء حقيبتها المستطيلة بطول وعرض وارتفاع 4 قدم و 3
                  أقدام و 2 أقدام على التوالي بالكيك. يتم حساب الحجم الدقيق
                  للكيك الذي يمكنها وضعه في حقيبتها أدناه:
                </p>
                <p>حجم = 2 × 3 × 4 = 24 قدم³</p>
                <br />
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <u>
                  <h3 style={{ fontSize: "16px" }}>
                    {" "}
                    حساب حجم الكبسولة - حاسبة حجم الكبسولة
                  </h3>{" "}
                </u>{" "}
              </div>
              <div className="info-section-body">
                <p>
                  الكبسولة هي شكل هندسي ثلاثي الأبعاد يتألف من أسطوانة واثنين من
                  الأطراف الهمسفيرية، حيث يعتبر الهمسفير نصف كرة. ونتيجة لذلك،
                  يمكن حساب حجم الكبسولة عن طريق دمج معادلات حجم الكرة وأسطوانة
                  الدائرة الصحيحة:
                </p>
                <p>حجم = πr²h + 4/3πr³ = πr²(4/3r + h)</p>
                <p>حيث r هو نصف القطر و h هو ارتفاع الجزء الأسطواني.</p>
                <p>
                  مثال: بناءً على كبسولة بنصف قطر 1.5 قدم وارتفاع 3 أقدام، حدد
                  حجم مكعبات الشوكولاتة المذابة التي يمكن لجو حملها في الكبسولة
                  الزمنية التي يرغب في دفنها للأجيال القادمة في رحلته لاكتشاف
                  ذاته عبر جبال الهملايا:
                </p>
                <p>حجم = π × 1.5² × 3 + 4/3 × π × 1.5³ = 35.343 قدم³</p>
                <br />
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <u>
                  <h3 style={{ fontSize: "16px" }}>
                    {" "}
                    حساب حجم الجذع المخروطية - حاسبة حجم الجذع المخروطية
                  </h3>{" "}
                </u>{" "}
              </div>
              <div className="info-section-body">
                <p>
                  المخروط المستوي هو الجزء من الجسم الصلب الذي يتبقى عندما يتم
                  قطع المخروط بواسطة سطحين متوازيين. تقوم هذه الحاسبة بحساب حجم
                  المخروط المستوي الصحيح بشكل خاص. أمثلة على المخروطات المستوية
                  في الحياة اليومية تشمل مظلات اللمبات وحاويات المياه وبعض أكواب
                  الشرب.
                </p>
                <p>
                  يتم حساب حجم المخروط المستوي الصحيح باستخدام المعادلة التالية:
                </p>
                <p>
                  <strong>
                    الحجم = (1/3) × πh(r<sup>2</sup> + rR + R<sup>2</sup>)
                  </strong>
                </p>
                <p>حيث r و R هما شعاعي قواعد المخروط، و h هو ارتفاع المخروط.</p>
                <h4>مثال:</h4>
                <p>
                  أحلام اقتنت بنجاح بعض الآيس كريم في قرون السكر، وتناولته
                  بطريقة تترك الآيس كريم داخل القرن بشكل مضغوط، وتكون سطح الآيس
                  كريم مستويًا ومتوازيًا لسطح فتحة القرن. أحلام على وشك أن تبدأ
                  في تناول قرنها والآيس كريم المتبقي عندما يمسك أخوها القرن
                  ويقضم قسمًا من قاع القرن الذي يكون متوازيًا تمامًا مع الفتحة
                  السابقة. الآن تظل أحلام بمخروط مستوي صحيح يتسرب منه الآيس
                  كريم، وعليها حساب حجم الآيس كريم الذي يجب عليها تناوله بسرعة
                  نظرًا لوجود ارتفاع قدره 4 بوصات، وشعاعي القاع 1.8 بوصة و 0.3
                  بوصة.
                </p>
                <p>
                  <strong>
                    الحجم = (1/3) × π × 4(0.3<sup>2</sup> + 0.3 × 1.8 + 1.8
                    <sup>2</sup>) = 12.547 بوصة مكعبة
                  </strong>
                </p>
                <br />
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <u>
                  <h3 style={{ fontSize: "16px" }}>
                    {" "}
                    حساب حجم الشكل البيضوي - حاسبة حجم الشكل البيضوي
                  </h3>{" "}
                </u>{" "}
              </div>
              <div className="info-section-body">
                <p>
                  الشكل البيضوي هو الشكل الثلاثي الأبعاد الذي ينشأ عن تشوه الكرة
                  بفضل تغيير مقياس العناصر الاتجاهية. يتم تحديد مركز الشكل
                  البيضوي عند نقطة تقاطع ثلاثة محاور تماثل متعامدة، ويطلق على
                  الخطوط التي تحدد هذه المحاور اسم المحاور الرئيسية. إذا كانت
                  لديها طول مختلف لكل ثلاثة، يتم وصف الشكل البيضوي عادة كثلاثي
                  الأمور المحورية. المعادلة لحساب حجم الشكل البيضوي هي كما يلي:
                </p>
                <p>
                  <strong>الحجم = (4/3) × πabc</strong>
                </p>
                <p>حيث a و b و c هي طول المحاور.</p>
                <h4>مثال:</h4>
                <p>
                  ليلى تحب فقط تناول الحلوى، ولكن أمها ترغب في مراقبة كمية
                  الحلوى التي تأكلها. تسمح لها والدتها بأكل الحلوى التي تتناسب
                  داخل كعكة بشكل إليبسويد. تقوم ليلى بنحت الكعكة لتحقيق الحد
                  الأقصى من حجم الحلوى التي يمكنها وضعها في الكعكة. بعد أن وجدت
                  أن الكعكة لديها طول محاور قدره 2.5 بوصة و 3 بوصة و 6 بوصات،
                  تقوم ليلى بحساب حجم الحلوى التي يمكنها وضعها في الكعكة
                  المنحوتة كما يلي:
                </p>
                <p>
                  <strong>
                    الحجم = (4/3) × π × 2.5 × 3 × 6 = 94.247 بوصة مكعبة
                  </strong>
                </p>
                <br />
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <u>
                  <h3 style={{ fontSize: "16px" }}>
                    {" "}
                    حساب حجم الهرم - حاسبة حجم الهرم
                  </h3>{" "}
                </u>{" "}
              </div>
              <div className="info-section-body">
                <p>
                  في الهندسة الرياضية، الهرم هو شكل ثلاثي الأبعاد يتكون من توصيل
                  قاع مضلع إلى نقطة تُعرف بقمته. الشكل المضلع هو شكل مستوٍ يحدده
                  عدد من الخطوط المستقيمة. يمكن أن يكون هناك أشكال مختلفة للأساس
                  للهرم، والهرم الرباعي يحدد أساساً بشكل مربع. موقع القمة يميز
                  أنواعًا مختلفة من الأهرامات، حيث يكون للهرم الصحيح قمة مباشرة
                  فوق مركز قاعده. يمكن حساب حجم الهرم، بغض النظر عن موقع القمة،
                  باستخدام الصيغة التالية:
                </p>
                <p>
                  <strong>حجم الهرم العام:</strong>
                </p>
                <p>
                  <strong>الحجم = (1/3) × bh</strong>
                </p>
                <p>حيث b هي مساحة القاعدة، و h هو الارتفاع.</p>
                <p>
                  <strong>حجم الهرم الرباعي:</strong>
                </p>
                <p>
                  <strong>
                    الحجم = (1/3) × a<sup>2</sup>h
                  </strong>
                </p>
                <p>حيث a هو طول حافة القاعدة.</p>
                <h4>مثال:</h4>
                <p>
                  يعشق آدم الحضارات القديمة ويشعر بإعجاب خاص بالهياكل مثل
                  الأهرامات. كونه الأكبر بين إخوته واحد، اثنان، وثلاثة، يستطيع
                  توجيههم بسهولة. استفادةً من ذلك، يقرر آدم إعادة إحياء العصور
                  القديمة ويجعل إخوته يتظاهرون بأنهم عمال يقومون ببناء هرم من
                  الطين بطول 5 أقدام وارتفاع 12 قدمًا، ويمكن حساب حجم هذا الهرم
                  باستخدام الصيغة للهرم الرباعي:
                </p>
                <p>
                  <strong>
                    الحجم = (1/3) × 5<sup>2</sup> × 12 = 100 قدم مكعبة
                  </strong>
                </p>
                <br />
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <u>
                  <h3 style={{ fontSize: "16px" }}>
                    {" "}
                    حساب حجم الانبوب - حاسبة حجم الانبوب
                  </h3>{" "}
                </u>{" "}
              </div>
              <div className="info-section-body">
                <p>
                  الأنبوب، يُشار إليه في كثير من الأحيان بالأنبوب، هو أسطوانة
                  مجوفة تُستخدم غالبًا لنقل السوائل أو الغاز. يشمل حساب حجم
                  الأنبوب أساسًا نفس الصيغة المستخدمة لحساب حجم الأسطوانة (الحجم
                  = πr²h)، باستثناء أنه في هذه الحالة يتم استخدام القطر بدلاً من
                  النصف القطر، ويتم استخدام الطول بدلاً من الارتفاع. لذا تشمل
                  الصيغة قياس قطري الأسطوانة الداخلية والخارجية، حساب حجم كل
                  منها، وطرح حجم الأسطوانة الداخلية من حجم الخارجية. بناءً على
                  استخدام الطول والقطر المذكورين أعلاه، تُظهر الصيغة لحساب حجم
                  الأنبوب أدناه:
                </p>
                <p>
                  <strong>الحجم = π × (d₁² - d₂²) / 4 × l</strong>
                </p>
                <p>
                  حيث d₁ هو القطر الخارجي، و d₂ هو القطر الداخلي، و l هو طول
                  الأنبوب.
                </p>
                <h4>مثال:</h4>
                <p>
                  ندى ملتزمة بالحفاظ على البيئة، حيث تستخدم مواد صديقة للبيئة في
                  شركتها للبناء. أحد العملاء لديه منزل عطلات في الغابة ويرغب في
                  بناء طريق عبر جدول مائي دون التأثير على مكانه المفضل لصيد
                  الأسماك. ندى تخطط لبناء أنبوب عبر الجدول لتجاوز السدود الناتجة
                  عن القنادس. يمكن حساب حجم الخرسانة ذات التأثير المنخفض اللازمة
                  لبناء أنبوب بقطر خارجي 3 أقدام، وقطر داخلي 2.5 أقدام، وطول 10
                  أقدام كما يلي:
                </p>
                <p>
                  <strong>الحجم = π × (3² - 2.5²) / 4 × 10 = 21.6 قدم³</strong>
                </p>
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default VolumesCalculator;
